<template>
  <div class="box">
    <div :class="`item-${msg}`" v-if="true">
      <div class="radio">
        <div class="radio-btn" :class="{ active: selected }"></div>
      </div>
      <div class="pic">
        <div
          class="pic-core"
          :style="{ backgroundImage: 'url(' + $setPicSize(this.portrait) + ')' }"
        ></div>
      </div>
      <div class="info">
        <div class="info-time">
          <span>{{ createTime }}</span>
        </div>
        <div class="info-content">
          <div class="info-content-item" v-if="isTxt">{{ content }}</div>
          <div class="info-content-img" v-if="isImg">
            <img width="100" :src="$setPicSize(this.content, 200, 200)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import setPicSize from '@zz-app/setPicSize'
import { getCookie } from '../../../../lib/utils'

export default {
  name: 'ListItem',
  data() {
    return {
      bagcolor: 'red'
    }
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    portrait: {
      type: String,
      default: ''
    },
    timeStamp: {
      type: String,
      default: ''
    },
    selected: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String,
      default: ''
    }
  },
  computed: {
    msg() {
      return this.userId === getCookie('uid') ? 'right' : 'left'
    },
    isTxt() {
      return this.type === '1'
    },
    isImg() {
      return this.type === '2'
    },
    createTime() {
      return this.timeStamp ? new Date(Number(this.timeStamp)).format('YYYY-MM-DD HH:mm:ss') : '' //  2018-02-21
    },
    result() {
      return this.userId === '1' ? '交易成功' : '交易失败'
    }
  },
  methods: {
    $setPicSize(url, width = 44, height = 44) {
      return setPicSize(url, width, height)
    }
  },
  mounted() {
    console.log('当前图片连接======>', this.content)
    console.log('setPic后===>', this.$setPicSize(this.content, 200, 200))
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
